<template>
  <b-container class="auth-page">
    <b-row class="justify-content-md-center">
      <b-col cols="12" xl="5" lg="6" md="8" sm="12">
        <div class="mt-4 b-form-1 basic-box-shadow">
          <h2>Conferma del cambio password</h2>
          <p>
            Conferma il cambio della password utilizzando il codice che hai
            ricevuto via email.
          </p>
          <b-form-group label="Email:" label-for="usernameInput">
            <b-form-input
              id="usernameInput"
              type="text"
              v-model="username"
              required
              autofocus
              placeholder="La tua email"
            />
          </b-form-group>
          <b-form-group label="Codice:" label-for="codeInput">
            <b-form-input
              id="codeInput"
              type="password"
              v-model="code"
              required
              placeholder="Il codice ricevuto via email"
            />
          </b-form-group>
          <b-form-group label="Password:" label-for="passwordInput">
            <b-form-input
              id="passwordInput"
              type="password"
              v-model="password"
              required
              placeholder="Scegli una nuova password"
            />
          </b-form-group>

          <b-button
            v-show="!submitting && !done"
            type="submit"
            variant="primary"
            class="mr-2"
            @click="confirmPasswordReset"
          >Conferma</b-button>

          <b-button
            v-show="!submitting && !done"
            variant="primary"
            @click="passwordResetResend"
          >Rinvia il codice</b-button>

          <b-button v-show="submitting" variant="primary" disabled>
            <b-spinner style="width: 1.4rem; height: 1.4rem;" label="Loading..."></b-spinner>
            <span class="sr-only">Loading...</span>
          </b-button>

          <b-button v-show="done" variant="success" disabled>
            <v-icon name="check" base-class="done-icon"></v-icon>
            <span class="sr-only">Done</span>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center mt-3">
      <b-col cols="12" xl="5" lg="6" md="8" sm="12">
        <v-alert />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*
  With this form, the user resetting his password, can confirm the reset with the code received by email.
*/

import Vue from 'vue'

import { mapGetters } from 'vuex'
import router from '@/router'
import store from '@/store'

import Alert from '@/components/auth/Alert.vue'

const { sleep } = require('sleep-async')().Promise

Vue.component('v-alert', Alert)

export default {
  data () {
    return {
      username: '',
      code: '',
      password: '',
      done: false,
      submitting: false
    }
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus'])
  },
  methods: {
    async confirmPasswordReset () {
      this.submitting = true
      // call the authentication method for confirming the password reset with the user's username, code received by name and the new chosen password
      await store.dispatch('auth/confirmPasswordReset', {
        username: this.username,
        code: this.code,
        password: this.password
      })
      this.submitting = false
      if (!this.hasAuthenticationStatus) {
        // show a checkmark for a short amount of time if the process went through
        this.done = true
        await sleep(1500)
        this.done = false
        // go back to the sign in page
        router.push({ name: 'signIn' }).catch(err => console.error(err))
      }
    },
    // resend the confirmation code by email
    async passwordResetResend () {
      this.submitting = true
      // call the authentication method for confirming the password reset with only the user's username in order to trigger a code resend to the user's email address
      await store.dispatch('auth/passwordReset', {
        username: this.username
      })
      this.submitting = false
      if (!this.hasAuthenticationStatus) {
        // show a checkmark for a short amount of time if the process went through
        this.done = true
        await sleep(1500)
        this.done = false
      }
    }
  }
}
</script>
